import React, { useEffect } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Home from '../pages/Home/Home';
import GrowPage from '../pages/Grow/GrowPage';
import SellOnlinePage from '../pages/SellOnline/SellOnlinePage';
import HowItWorksPage from '../pages/HowItWorks/HowItWorksPage';
import PricingPage from '../pages/Pricing/PricingPage';
import ShippingReturnsPage from '../pages/ShippingReturns/ShippingReturnsPage';
import AdvertisingHubPage from '../pages/AdvertisingHub/AdvertisingHubPage';
import AdCheckoutPage from '../pages/AdCheckout/AdCheckoutPage';
import DontHaveGSTIN from '../pages/DontHaveGSTIN/DontHaveGSTIN';
import ContactUsPage from '../pages/ContactUs/ContactUsPage';
import Newsroom from '../pages/Newsroom/Newsroom';
import NewsroomDetail from '../pages/Newsroom/NewsroomDetail';

// Re-enforces scroll on every page navigation
function ScrollEnforcer() {
  const { pathname } = useLocation();

  useEffect(() => {
    const html = document.documentElement;
    const body = document.body;
    const root = document.getElementById('root');

    [html, body].forEach(el => {
      if (el) {
        el.style.setProperty('overflow-y', 'auto', 'important');
        el.style.setProperty('overflow-x', 'hidden', 'important');
        el.style.setProperty('height', 'auto', 'important');
        el.style.setProperty('touch-action', 'auto', 'important');
      }
    });

    if (root) {
      root.style.setProperty('overflow', 'visible', 'important');
      root.style.setProperty('height', 'auto', 'important');
    }

    // Scroll to top on page change
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

export default function SellerRoutes() {
  return (
    <>
      <ScrollEnforcer />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/grow" element={<GrowPage />} />
        <Route path="/sellonline" element={<SellOnlinePage />} />
        <Route path="/how-it-works" element={<HowItWorksPage />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/fees-and-commission" element={<PricingPage />} />
        <Route path="/shipping" element={<ShippingReturnsPage />} />
        <Route path="/shipping-returns" element={<ShippingReturnsPage />} />
        <Route path="/newsroom" element={<Newsroom />} />
        <Route path="/newsroom/:id" element={<NewsroomDetail />} />
        <Route path="/advertising" element={<AdvertisingHubPage />} />
        <Route path="/advertising-hub" element={<AdvertisingHubPage />} />
        <Route path="/ad-checkout" element={<AdCheckoutPage />} />
        <Route path="/checkout" element={<AdCheckoutPage />} />
        <Route path="/donothavegst" element={<DontHaveGSTIN />} />
        <Route path="/pricing-plans/list" element={<DontHaveGSTIN />} />
        <Route path="/contactus" element={<ContactUsPage />} />
        
        {/* Catch-all for unmatched routes in the public seller app */}
        <Route path="*" element={<Navigate to="/signin" replace />} />
      </Routes>
    </>
  );
}
